import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResult } from '../../models/api-result.models';

@Injectable({ providedIn: 'root' })
export class FontesTrafegoService {
    private readonly urlBase = environment.urlApi;
    readonly redeAdsAtivasUpdated$ = new Subject<void>();

    constructor(private httpClient: HttpClient) {}

    public updateRedeAdsAtivas(redeAdsAtivas: number[] | null): Observable<ApiResult> {
        return this.httpClient.put<ApiResult>(`${this.urlBase}/cliente/rede-ads-ativas`, {
            rede_ads_ativas: redeAdsAtivas,
        });
    }
}
